// @ts-nocheck
import React from 'react';

import Dialog from 'crehana-ui/Dialog';
import BasicDataForm from 'Jsx/Auth/components/BasicDataForm';

type PhoneNumberDialogProps = {
  redirectUrl?: string;
  isOpen: boolean;
  onClose(): void;
  onSuccess?(): void;
};

const PhoneNumberDialog: React.FC<PhoneNumberDialogProps> = ({
  redirectUrl,
  isOpen,
  onClose,
  onSuccess,
}) => {
  return (
    <Dialog
      size="s"
      open={isOpen}
      onDismiss={onClose}
      ignoreBackdropClick
      ignoreEscape
    >
      <div className="py-56 px-48">
        <BasicDataForm
          redirectUrl={redirectUrl}
          onlyPhoneNumber
          hideLegalInfo
          phoneNumberOptions={{
            isRequired: true,
          }}
          onSuccess={onSuccess}
        />
      </div>
    </Dialog>
  );
};

export default PhoneNumberDialog;
